import React, { useContext, useEffect, useRef, useState } from "react";
import AppSettings from "../../../../Settings/AppSettings";
import { AttributeContext } from "../AttributeContext";
import Utils from "../../../../Common/Utils";
import Label from "../../../Common/components/Label";
import EditAttValues from './EditAttValues'

import { listAttributeValuesByAttributeID } from "api/Attributes";

const AttributeValues = ({
  aDetail,
  finalAttributeValues,
  setFinalAttributeValues,
  attributeValueCount
}) => {
  const { editingItem, attributeLoading, setAttributeLoading } = useContext(AttributeContext);
  const [loading, setLoading] = useState({
    status: "",
    message: "",
  });

  const [attValues, setAttValues] = useState(null);
  const [attValuesCount, setAttValuesCount,] = useState(attributeValueCount);
  const [collapse, setCollapse] = useState(false);
  const [search, setSearch] = useState(undefined)
  const initialLoading = useRef(true)

  useEffect(() => {
    if (collapse && attValues === null) {
      initialLoading.current = true;
      load_attribute_values().then((r) => initialLoading.current = false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [collapse]);

  useEffect(() => {
    setLoading({
      status: "",
      message: "",
      message2: "",
    });
    setAttValues(null)
    setAttValuesCount(attributeValueCount ?? 0)
    setFinalAttributeValues([]);
  }, [editingItem.id])


  function handle_collapse() {
    setCollapse(!collapse);
  }

  async function load_attribute_values(search, skip, reset) {
    const limit = skip !== undefined ? 10 + skip : 10;
    if(reset) setAttValues(null)
    setAttributeLoading(true)
    setLoading({ status: "Loading", message: "Loading Attribute values" });
    if (aDetail && initialLoading.current) {
      setAttValues(aDetail.data);
      setLoading({ status: "Success", message: undefined });
      setAttributeLoading(false)
      return
    } 

    listAttributeValuesByAttributeID(editingItem.id, limit, skip, search)
    .then(({attribute_values, count}) => {
      setAttValuesCount(count)
      setAttValues((prev) => {
        return prev?.length > 0 && !reset ? [...prev, ...attribute_values] : attribute_values
      })
      setLoading({ status: "Success", message: undefined });
    })
    .catch(() => {
      setLoading({ status: "Error", message: "Error while loading details" });

      setTimeout(() => {
        setLoading({
          status: "Error",
          message: undefined,
        });
      }, 2000)
    }).finally(()=>setAttributeLoading(false))

  }

  useEffect(() => {
    if(initialLoading.current) return
    load_attribute_values(search, undefined, true)
  }, [search])

  return (
    <>
      <div className="accordion" id="accordionFlushAttv">
        <div className="accordion-item border-0">
          <div
            className="accordion-button bg-white collapsed"
            onClick={() => handle_collapse()}
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#flush-collapseAttv"
            aria-controls="flush-collapseAttv"
            style={Utils.borderStyle()}
          >
            <div>
              <Label message="Attribute Values" />
            </div>
          </div>

          <div
            id="flush-collapseAttv"
            className="accordion-collapse collapse"
            aria-labelledby="flush-headingAttv"
            data-bs-parent="#accordionFlushAttv"
          >
            <div className="accordion-body p-0" style={{ minHeight: "30px" }}>
              {initialLoading && loading.status === "Loading" && (
                <div
                  className="aalert alert-primary bg-white small p-2"
                  role="alert"
                >
                  <span className="fas fa-circle-notch fa-spin" />
                  &nbsp;
                  <strong>{loading.message}</strong>
                </div>
              )}

              {/*{loading.status !== 'Error' && <LoadingSuccessErrorAlert loading={loading}/>}*/}
              {attValues && (
                <>
                  <div className="card shadow mb-3 bg-body rounded border-top-0 p-0">
                    {attValues && (
                      <EditAttValues
                        attValues={attValues}
                        setAttValues={setAttValues}
                        loading={loading}
                        setLoading={setLoading}
                        finalAttributeValues={finalAttributeValues}
                        setFinalAttributeValues={setFinalAttributeValues}
                        fetchAttributeValues={load_attribute_values}
                        attValuesCount={attValuesCount}
                        search={search}
                        setSearch={setSearch}
                      />
                    )}
                  </div>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AttributeValues;
